var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodeContactDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2509 7.68041C12.258 7.24777 12.1061 6.84291 12.1061 6.44202C12.1061 6.00938 12.3787 5.60452 12.7058 5.29492C13.2743 4.73923 13.578 3.99302 13.578 3.09598C13.578 1.42494 12.6123 0 10.8679 0C9.81261 0 9.06109 0.49615 8.6055 1.27015C9.81261 2.19894 10.5641 3.71518 10.5641 5.57276C10.5641 6.65636 10.2916 7.64866 9.7503 8.48219C9.53614 8.79179 9.66075 9.19268 9.99173 9.37923C10.9847 9.87538 12.1645 10.6176 12.7953 11.7925C12.8849 11.9791 13.099 12.1021 13.3132 12.1021H14.6099C15.4237 12.1021 16 11.4512 16 10.5541C15.9688 9.19268 14.6722 8.32342 13.2587 7.67644H13.2509V7.68041Z",
    fill: "#0D2045"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36018 10.6533C7.27379 10.189 7.12193 9.75631 7.12193 9.29191C7.12193 8.82751 7.42565 8.36312 7.78389 8.02177C8.4147 7.43432 8.77683 6.56507 8.77683 5.57674C8.77683 3.7509 7.69044 2.17116 5.76296 2.17116C3.83548 2.17116 2.74909 3.7509 2.74909 5.57674C2.74909 6.56904 3.11511 7.40257 3.74203 8.02177C4.10806 8.36312 4.40399 8.82751 4.40399 9.29191C4.40399 9.75631 4.22098 10.189 3.16573 10.6533C1.54198 11.3361 0.0311511 12.1378 0 13.6263C0 14.6186 0.689218 15.4839 1.5926 15.4839H9.85544C10.7588 15.4839 11.448 14.6186 11.448 13.6263C11.4169 12.1418 9.91385 11.3361 8.34072 10.6533H8.36018Z",
    fill: "#0D2045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeContactDuplicate);
export default __webpack_public_path__ + "static/media/nodeContactDuplicate.b29e0ffbfc0ebfcc5eddbfd4cc9d21d1.svg";
export { ForwardRef as ReactComponent };